<div class="space-y-4 sm:space-y-6">
  <!-- Filters -->
  <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
    <div class="flex flex-col sm:flex-row sm:items-center gap-3">
      <div class="grid grid-cols-1 xs:grid-cols-2 sm:flex sm:flex-row gap-3 flex-1">
        <!-- Bitta do'konda filtr yashiriladi: "hammasi" bilan bir xil natija beradi. -->
        @if (storePick.visible()) {
          <p-multiselect
            [options]="stores()"
            optionLabel="name"
            optionValue="id"
            [placeholder]="'ANALYTICS.FILTER.ALL_STORES' | translate"
            [showClear]="true"
            [(ngModel)]="filterStoreIds"
            display="chip"
            appendTo="body"
            class="w-full sm:w-52"
          />
        }
        <p-datepicker
          [(ngModel)]="filterFrom"
          [placeholder]="'ANALYTICS.FILTER.FROM' | translate"
          dateFormat="dd.mm.yy"
          [showClear]="true"
          class="w-full sm:w-36"
        />
        <p-datepicker
          [(ngModel)]="filterTo"
          [placeholder]="'ANALYTICS.FILTER.TO' | translate"
          dateFormat="dd.mm.yy"
          [showClear]="true"
          class="w-full sm:w-36"
        />
        <!--
          Valyuta tanlagichi FAQAT bir nechta valyuta yoqilgan bo'lsa chiqadi.
          Hamma grafik va karta shu valyuta daftaridan o'qiladi (I1).
        -->
        @if (currencySvc.hasMultipleCurrencies()) {
          <p-select
            [options]="currencySvc.currencyOptions()"
            optionLabel="label"
            optionValue="value"
            [ngModel]="currency()"
            (ngModelChange)="onCurrencyChange($event)"
            [ariaLabel]="'ANALYTICS.FILTER.CURRENCY' | translate"
            appendTo="body"
            class="w-full sm:w-40"
          />
        }
      </div>
      <p-button
        [label]="'ANALYTICS.FILTER.APPLY' | translate"
        icon="pi pi-search"
        severity="secondary"
        [loading]="loading()"
        (onClick)="loadAnalytics()"
        styleClass="w-full sm:w-auto"
      />
    </div>
  </div>

  <!-- KPI Cards -->
  <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
    @for (card of kpiCards(); track card.name) {
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-3 sm:p-5 shadow-sm"
      >
        <div class="flex items-start justify-between gap-2">
          <div class="min-w-0">
            <p class="text-xs sm:text-sm text-gray-500 dark:text-gray-400 truncate">
              {{ card.name }}
            </p>
            @if (loading()) {
              <div
                class="mt-1.5 h-5 w-16 sm:h-7 sm:w-24 animate-pulse rounded bg-gray-200 dark:bg-gray-700"
              ></div>
            } @else {
              <p
                class="mt-1 text-sm sm:text-xl font-bold text-gray-900 dark:text-gray-100 leading-tight"
              >
                @if (card.money) {
                  {{ card.value | moneyFixed: currency() }}
                } @else {
                  {{ card.value | moneyValue }}
                }
              </p>
            }
          </div>
          <div
            [class]="card.color"
            class="flex-shrink-0 flex h-8 w-8 sm:h-10 sm:w-10 items-center justify-center rounded-lg"
          >
            <lucide-icon [img]="card.icon" class="h-4 w-4 sm:h-5 sm:w-5"></lucide-icon>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Dynamic Charts -->
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 sm:items-stretch">
    <!-- Donut card -->
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm flex flex-col"
    >
      <div class="p-4 sm:p-5 pb-2 sm:pb-3">
        <h3 class="text-sm sm:text-base font-semibold text-gray-900 dark:text-gray-100">
          {{ 'ANALYTICS.CHARTS.CATEGORIES' | translate }}
        </h3>
        <p class="text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-0.5">
          {{ 'ANALYTICS.CHARTS.CATEGORIES_SUB' | translate }}
        </p>
      </div>
      <div class="p-4 sm:p-5 pt-0 flex flex-col flex-1">
        <div class="flex items-center gap-4 sm:flex-col sm:items-stretch">
          <div
            class="relative w-[150px] h-[150px] sm:w-[140px] sm:h-[140px] md:w-[180px] md:h-[180px] lg:w-[230px] lg:h-[230px] mx-auto"
          >
            <!--
              Yuklanayotganda bo'sh grafik ko'rsatilmaydi: u "ma'lumot yo'q" degandek
              o'qilardi. Doira skeleti kelayotgan shaklni oldindan bildiradi.
            -->
            @if (loading()) {
              <div
                class="h-full w-full rounded-full border-[16px] border-gray-100 dark:border-gray-800 animate-pulse"
              ></div>
            } @else {
              <p-chart type="doughnut" [data]="donutData()" [options]="donutOptions" />
              <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div class="text-center">
                  <p class="text-[10px] sm:text-[11px] text-gray-400 dark:text-gray-500">
                    {{ 'ANALYTICS.KPI.PROFIT' | translate }}
                  </p>
                  <p class="text-sm sm:text-base font-bold text-emerald-500 leading-tight">
                    {{ analytics()?.grossProfit ?? 0 | moneyFixed: currency() }}
                  </p>
                </div>
              </div>
            }
          </div>

          <div class="flex-1 sm:mt-0 space-y-2">
            <div class="flex items-center justify-between text-xs sm:text-sm">
              <div class="flex items-center gap-1.5">
                <span class="h-2.5 w-2.5 rounded-full bg-amber-400 flex-shrink-0"></span>
                <span class="text-gray-500 dark:text-gray-400">{{
                  'ANALYTICS.KPI.COST' | translate
                }}</span>
              </div>
              @if (loading()) {
                <div class="h-4 w-20 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
              } @else {
                <span class="font-semibold text-amber-500 ml-2 tabular-nums">
                  {{ analytics()?.totalCOGS ?? 0 | moneyFixed: currency() }}
                </span>
              }
            </div>
            <div class="flex items-center justify-between text-xs sm:text-sm">
              <div class="flex items-center gap-1.5">
                <span class="h-2.5 w-2.5 rounded-full bg-emerald-500 flex-shrink-0"></span>
                <span class="text-gray-500 dark:text-gray-400">{{
                  'ANALYTICS.KPI.PROFIT' | translate
                }}</span>
              </div>
              @if (loading()) {
                <div class="h-4 w-20 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
              } @else {
                <span class="font-semibold text-emerald-500 ml-2 tabular-nums">
                  {{ analytics()?.grossProfit ?? 0 | moneyFixed: currency() }}
                </span>
              }
            </div>
            <div
              class="flex items-center justify-between text-xs sm:text-sm border-t border-gray-100 dark:border-gray-800 pt-2"
            >
              <div class="flex items-center gap-1.5">
                <span class="h-2.5 w-2.5 rounded-full bg-green-500 flex-shrink-0"></span>
                <span class="text-gray-500 dark:text-gray-400">{{
                  'ANALYTICS.KPI.REVENUE' | translate
                }}</span>
              </div>
              @if (loading()) {
                <div class="h-4 w-24 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
              } @else {
                <span class="font-semibold text-green-500 ml-2 tabular-nums">
                  {{ analytics()?.totalRevenue ?? 0 | moneyFixed: currency() }}
                </span>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bar chart card -->
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm flex flex-col"
    >
      <div class="p-4 sm:p-5 pb-2 sm:pb-3">
        <h3 class="text-sm sm:text-base font-semibold text-gray-900 dark:text-gray-100">
          {{ 'ANALYTICS.CHARTS.TREND' | translate }}
        </h3>
        <p class="text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-0.5">
          {{ 'ANALYTICS.CHARTS.TREND_SUB' | translate }}
        </p>
      </div>
      <div class="p-4 sm:p-5 pt-0 flex flex-col flex-1">
        <div class="flex-1 min-h-[150px] sm:min-h-[200px]">
          @if (loading()) {
            <div
              class="h-full min-h-[150px] sm:min-h-[200px] rounded bg-gray-100 dark:bg-gray-800 animate-pulse"
            ></div>
          } @else {
            <p-chart type="bar" [data]="financialBarData()" [options]="financialBarOptions" />
          }
        </div>
        <div
          class="mt-3 flex items-center gap-1.5 text-xs sm:text-sm text-gray-500 dark:text-gray-400"
        >
          <span class="inline-block h-2 w-2 rounded-full bg-green-500"></span>
          @if (loading()) {
            <div class="h-4 w-20 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
          } @else {
            {{ analytics()?.totalItemsSold ?? 0 | moneyValue }}
            {{ 'COMMON.UNIT_PIECE' | translate }}
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Static Charts -->
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
    <!-- Revenue Trend -->
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm"
    >
      <div class="p-4 sm:p-6 pb-2 sm:pb-3">
        <h3 class="text-sm sm:text-lg font-semibold text-gray-900 dark:text-gray-100">
          {{ 'ANALYTICS.CHARTS.TREND' | translate }}
        </h3>
        <p class="text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-0.5">
          {{ 'ANALYTICS.CHARTS.TREND_SUB' | translate }}
        </p>
      </div>
      <div class="p-4 sm:p-6 pt-0">
        <div class="h-[180px] sm:h-[200px]">
          @if (loading()) {
            <div class="h-full rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
          } @else {
            <p-chart type="line" [data]="revenueTrendData()" [options]="revenueTrendOptions" />
          }
        </div>
      </div>
    </div>

    <!-- Orders by hour -->
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm"
    >
      <div class="p-4 sm:p-6 pb-2 sm:pb-3">
        <h3 class="text-sm sm:text-lg font-semibold text-gray-900 dark:text-gray-100">
          {{ 'ANALYTICS.CHARTS.HOURLY' | translate }}
        </h3>
        <p class="text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-0.5">
          {{ 'ANALYTICS.CHARTS.HOURLY_SUB' | translate }}
        </p>
      </div>
      <div class="p-4 sm:p-6 pt-0">
        <div class="h-[180px] sm:h-[200px]">
          @if (loading()) {
            <div class="h-full rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
          } @else {
            <p-chart type="bar" [data]="ordersBarData()" [options]="ordersBarOptions" />
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Category Bar -->
  <div
    class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm"
  >
    <div class="p-4 sm:p-6 pb-2 sm:pb-3">
      <h3 class="text-sm sm:text-lg font-semibold text-gray-900 dark:text-gray-100">
        {{ 'ANALYTICS.CHARTS.CATEGORIES' | translate }}
      </h3>
      <p class="text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-0.5">
        {{ 'ANALYTICS.CHARTS.CATEGORIES_SUB' | translate }}
      </p>
    </div>
    <div class="p-4 sm:p-6 pt-0">
      <div class="h-[200px] sm:h-[220px]">
        @if (loading()) {
          <div class="h-full rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
        } @else {
          <p-chart type="bar" [data]="categoryBarData()" [options]="categoryBarOptions" />
        }
      </div>
    </div>
  </div>
</div>
